import { render } from "./TaahodatO.vue?vue&type=template&id=2d353cea&scoped=true"
import script from "./TaahodatO.vue?vue&type=script&lang=js"
export * from "./TaahodatO.vue?vue&type=script&lang=js"

import "./TaahodatO.vue?vue&type=style&index=0&id=2d353cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d353cea"]])

export default __exports__